// src/components/ui/ThreeDotLoader.js
import React from 'react';

/**
 * Three-dot jumping loader animation
 * @param {string} className - Additional CSS classes
 * @param {number} size - Size of each dot in pixels (default: 8)
 * @param {string} color - Color class for dots (default: 'bg-app-gray-400')
 */
const ThreeDotLoader = ({ 
  className = '', 
  size = 6,
  color = 'bg-app-gray-600'
}) => {
  // Custom keyframes for a higher bounce
  const bounceAnimation = `
    @keyframes higherBounce {
      0% {
        transform: translateY(0);
      }
      20% {
        transform: translateY(-8px);
      }
      40%, 100% {
        transform: translateY(0);
      }
    }
  `;

  const dotStyle = {
    width: `${size}px`,
    height: `${size}px`,
    animation: 'higherBounce 1200ms ease-in-out infinite',
    WebkitBackfaceVisibility: 'hidden',
    backfaceVisibility: 'hidden',
    transform: 'translateZ(0)',
    willChange: 'transform'
  };

  return (
    <>
      <style>{bounceAnimation}</style>
      <div className={`flex items-center gap-[3px] ${className}`}>
        <div 
          className={`${color} rounded-full`}
          style={{ 
            ...dotStyle,
            animationDelay: '0ms'
          }}
        />
        <div 
          className={`${color} rounded-full`}
          style={{ 
            ...dotStyle,
            animationDelay: '150ms'
          }}
        />
        <div 
          className={`${color} rounded-full`}
          style={{ 
            ...dotStyle,
            animationDelay: '300ms'
          }}
        />
      </div>
    </>
  );
};

export default ThreeDotLoader;